module.exports = __webpack_public_path__ + "876e2ce8a417c634ca311b6e31538d1f.MP3";